var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetsMgt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.772 12.57c.136 0 .265.054.361.15h0l2.123 2.128a.511.511 0 010 .873h0l-2.123 2.13a.51.51 0 01-.853-.23.513.513 0 01.132-.495h0l1.284-1.288H11.58a.531.531 0 010-1.064h5.115l-1.284-1.256a.512.512 0 01.36-.873h0zM9.458 2c4.396 0 7.96 3.574 7.96 7.984h0-1.062a6.92 6.92 0 00-4.258-6.393 6.882 6.882 0 00-7.517 1.5 6.935 6.935 0 00-1.495 7.54 6.897 6.897 0 006.372 4.272h0v1.064c-4.395 0-7.958-3.574-7.958-7.983C1.5 5.574 5.063 2 9.458 2zm1.663 4.628a.48.48 0 01.353.154.541.541 0 010 .741h0l-1 1.05h1.053c.282.007.504.24.5.522a.512.512 0 01-.5.523h0-1.501v1.046h1.5c.283.007.505.24.501.523a.515.515 0 01-.5.522h0-1.501v1.396a.515.515 0 01-.5.523.513.513 0 01-.5-.523h0v-1.396H7.527a.513.513 0 01-.5-.522.512.512 0 01.5-.523h1.497V9.618H7.528a.513.513 0 01-.5-.523.512.512 0 01.5-.523h1.057L7.581 7.523a.541.541 0 010-.741.48.48 0 01.707 0h0L9.529 8.08l1.238-1.298a.48.48 0 01.354-.154z",
    stroke: "#FFF",
    strokeWidth: 0.3,
    fill: "currentColor",
    fillRule: "nonzero",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsMgt);
export default __webpack_public_path__ + "static/assets/assetsMgt.a2f4fe66.svg";
export { ForwardRef as ReactComponent };